export const RoutesMapping = Object.freeze({
  LANDING: '/landing',
  NOT_FOUND: '*',
  NOT_FOUND_ROUTE: '/404',
  INTERNAL_SERVER_ERROR: '/500',
  HOME: '',
  ORDERS: '/orders',
  ORDERS_LIST: '',
  ORDERS_DETAILS: '/orders/:orderId',
  CREATE_PUBLIC_ORDER: '/:storeNameId', // Legacy for some initial companies
  CREATE_PUBLIC_ORDER2: '/c/:storeNameId',
  CREATE_PUBLIC_ORDER3: '/p/:storeNameId', // Legacy for privalia
  CREATE_PUBLIC_ORDER4: '//p/:storeNameId', // Legacy for privalia
  SELECT_RETURN_METHOD: '/select-return/:storeNameId/:orderId',
  DEVOLUTION_PAGE_COFIGS: '/devolution-page-configs',
  CONFIGURATION_RULES: '/rules',
  INTEGRATIONS: '/integrations',
  PROFILE: '/profile',
  EMAILS: '/emails',
  SELECT_RETURN_METHOD_EMAIL: '/emails/select-return-method',
  CLIQUERETIRE_APPROVED_EMAIL: '/emails/cliqueretire-approved',
  CORREIOS_APPROVED_EMAIL: '/emails/correios-approved',
});
